import { Main } from './components';

const PayoutItems = () => <Main />;

export default PayoutItems;

